export default __webpack_public_path__ + "img/bhuVGUVU.e792074a.svg";